import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../css/privacy.scss";

export default function InformationPage({ title, number, kicker, introduction, sections }) {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return (
    <main className="policy-page">
      <header className="policy-hero">
        <span className="policy-hero__number">{number}</span>
        <p>{kicker}</p>
        <h1>{title}</h1>
        <p className="policy-hero__intro">{introduction}</p>
        <span className="policy-hero__date">Updated September 16, 2026</span>
      </header>
      <div className="policy-layout">
        <aside className="policy-index">
          <p>ON THIS PAGE</p>
          <nav aria-label={`${title} sections`}>
            {sections.map(({ id, heading }) => <a key={id} href={`#${id}`}>{heading}</a>)}
          </nav>
        </aside>
        <article className="policy-content">
          {sections.map(({ id, heading, content }, index) => (
            <section key={id} id={id}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <h2>{heading}</h2>
              {content}
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}
